export const SEARCH_KEYWORDS = "v1/keywordSuggest";
export const SUGGESTED_KEYWORDS = "v1/autoSuggest";
export const RECENT_SEARCHES = "v1/recentSearches";
export const MASTER_DATA = "v1/master-data";

export const CATEGORIZE_KEYWORDS = "named-entity/categorize_keywords"